import { createSelector } from 'reselect';
import {
  compareGoalsDataOrDefaultSelector,
  whatIfInnerSelector,
  impactSelector,
} from '../WhatIfsSelector';

export const goalsAdditionalSavingsWhatIfsOrDefaultSelector = createSelector(
  compareGoalsDataOrDefaultSelector,
  whatIfInnerSelector,
  impactSelector,
  (compareGoalsDataOrDefault, whatIfInner, impactArray) =>
    (compareGoalsDataOrDefault.GoalsAdditionalSavingsWhatIfs || []).map(whatIfCompareGoals => {
      if (whatIfCompareGoals.WhatIfPanelItem.WhatIf.WhatIfKey === whatIfInner.WhatIfKey) {
        return {
          ...whatIfCompareGoals,
          WhatIfPanelItem: {
            ...whatIfCompareGoals.WhatIfPanelItem,
            WhatIf: whatIfInner,
          },
          WhatIfPlanImpact: [
            {
              Key: whatIfInner.WhatIfKey,
              Value: impactArray.map(impact => ({
                Label: impact.label,
                Proposed: impact.proposed,
                Current: impact.current,
              })),
            },
          ],
        };
      }
      return whatIfCompareGoals;
    }),
);

export const whatIfsNoImpactsOrDefaultSelector = createSelector(
  goalsAdditionalSavingsWhatIfsOrDefaultSelector,
  goalsAdditionalSavingsWhatIfsOrDefault =>
    goalsAdditionalSavingsWhatIfsOrDefault.map(({ WhatIfPanelItem }) => WhatIfPanelItem.WhatIf),
);
